/**
 * PartnerSection — MADE-258
 *
 * Static placeholder only. No form, no registration, no backend.
 * Plants the flag for a future sprint that will define the Partner Program.
 */

import { Box, Container, Typography } from '@mui/material';

export function PartnerSection() {
  return (
    <Box
      component="section"
      aria-labelledby="partner-headline"
      sx={{
        backgroundColor: 'white',
        py: { xs: 8, md: 10 },
        borderTop: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            background: 'linear-gradient(135deg, rgba(102,126,234,0.06) 0%, rgba(118,75,162,0.06) 100%)',
            border: '1px solid rgba(102,126,234,0.16)',
            borderRadius: 4,
            p: { xs: 4, md: 6 },
            textAlign: 'center',
          }}
        >
          <Typography
            id="partner-headline"
            variant="h2"
            component="h2"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              color: '#1a1a2e',
              mb: 2.5,
              letterSpacing: '-0.01em',
            }}
          >
            Partner Program
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#555',
              fontSize: { xs: '1rem', md: '1.1rem' },
              lineHeight: 1.85,
              maxWidth: 540,
              mx: 'auto',
            }}
          >
            Interested in partnering with Made.bb? We are building a network of trusted partners
            across the Caribbean and beyond — distributors, designers, and industry specialists
            who share our commitment to precision and quality. Details coming soon.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
